import { forwardRef, type ReactNode } from "react";
import classNames from "classnames";

interface PageHeaderElementProps {
  className?: string;
  parentClassName?: string;
  children?: ReactNode;
}

const PageHeaderElement = forwardRef<HTMLDivElement, PageHeaderElementProps>((props, ref) => (
  <div className={classNames("scha__header-element", props.parentClassName)} ref={ref}>
    <div className={classNames("container", props.className)}>{props.children}</div>
  </div>
));

export default PageHeaderElement;
